$(document).ready(function () {
  // money format code start here

  Shopify.money_format = "£{{amount}}";
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  //  console.log(Shopify.formatMoney(62160))

  // money format code end here

  $(".scrollTo").click(function (e) {
    let jump = $(this).attr("href");
    let new_position = $(jump).offset();
    let scroll = -20;
    $("html, body")
      .stop()
      .animate({ scrollTop: new_position.top + scroll }, 800, function () {
        let new_position = $(jump).offset();
        $("html, body")
          .stop()
          .animate({ scrollTop: new_position.top + scroll }, 800);
      });
    e.preventDefault();
  });

  // Menu open close Script Start Here
  $(document).on("click", ".js-hamburger-menu", function () {
    console.log("drawer open!!");
    $("body").toggleClass("open-menu");
    $("html").toggleClass("open-menu");
    $(this).toggleClass("active");
  });

  $(document).on("click", function (event) {
    let $trigger = $(".js-hamburger-menu, .eq-header__bottom");
    if ($trigger !== event.target && !$trigger.has(event.target).length) {
      // Bug-fix 14-May-2026: also strip `.open-menu` from <html>.
      // The hamburger click above adds the class to BOTH <body> and
      // <html> (so the scroll-lock CSS can target either), but this
      // outside-click handler used to only clean up <body>. Result:
      // tapping anywhere in the header (outside the menu drawer) to
      // dismiss the menu left <html> stuck with `.open-menu`, and
      // because the scroll-lock rule sits on `html.open-menu`, page
      // scrolling stayed disabled until the user explicitly tapped
      // the X. Mirror what the hamburger toggle does on open.
      $("body").removeClass("open-menu");
      $("html").removeClass("open-menu");
      $(".js-hamburger-menu").removeClass("active");
    }
  });
  // Menu open close Script End Here

  // USPA Slider Start Here
  if ($(".js-uspa-slider").length > 0) {
    $(".js-uspa-slider").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      variableWidth: false,
      dots: false,
      draggable: false,
      pauseOnHover: false,
      swipeToSlide: false,
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75 10.5L5.25 7L8.75 3.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.25 10.5L8.75 7L5.25 3.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            variableWidth: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
            arrows: true,
          },
        },
      ],
    });
  }
  // USPA Slider Start Here

  // js-trusted-by-slider Start Here
  if ($(".js-trusted-by-slider").length > 0) {
    $(".js-trusted-by-slider").slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      variableWidth: false,
      dots: false,
      draggable: false,
      pauseOnHover: false,
      swipeToSlide: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            variableWidth: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            variableWidth: false,
            arrows: false,
          },
        },
      ],
    });
  }
  // js-trusted-by-slider Start Here

  // js-product-slider Start Here
  if ($(".js-product-slider").length > 0) {
    $(".js-product-slider").slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      variableWidth: false,
      dots: false,
      draggable: false,
      pauseOnHover: true,
      swipeToSlide: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3.12,
          },
        },
      ],
    });
  }
  // js-product-slider Start Here

  // js-our-customers Start Here
  if ($(".js-our-customers").length > 0) {
    $(".js-our-customers").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 2000,
      variableWidth: false,
      dots: false,
      draggable: true,
      pauseOnHover: false,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            autoplay: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            autoplay: true,
          },
        },
      ],
    });
  }
  // js-our-customers Start Here

  // js-as-featured-slider Start Here
  if ($(".js-as-featured-slider").length > 0) {
    $(".js-as-featured-slider").slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      variableWidth: false,
      dots: false,
      draggable: false,
      pauseOnHover: false,
      swipeToSlide: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            autoplay: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            autoplay: true,
          },
        },
      ],
    });
  }
  // js-as-featured-slider Start Here

  // Case Studies Slider Start Here
  // 20-May-2026 redesign — Slick's built-in arrows are replaced by
  // the custom prev/next buttons rendered in the section header
  // (`.js-case-studies-prev` / `-next`). The slider's own arrows
  // are hidden via CSS so we get full styling control of the
  // header buttons. A live counter ("1 – 2 of N case studies")
  // also lives in the header and is updated on every slide change.
  if ($(".js-case-studies-slider").length > 0) {
    var $slider = $(".js-case-studies-slider");
    var $section = $slider.closest(".case-studies");
    var $prevBtn = $section.find(".js-case-studies-prev");
    var $nextBtn = $section.find(".js-case-studies-next");
    var $counterCurrent = $section.find("[data-cs-counter-current]");
    var $counterEnd     = $section.find("[data-cs-counter-end]");
    var totalCount = parseInt($section.attr("data-total-count"), 10) || 0;

    // Compute the highest "end" index visible at the current
    // breakpoint based on the section's data-slides-* attributes.
    // Returns 1-based end index (inclusive).
    function visibleEndIndex(currentSlide, slidesToShow) {
      var endIdx = currentSlide + slidesToShow;
      if (endIdx > totalCount) endIdx = totalCount;
      return endIdx;
    }

    // Update the "X – Y of N" counter text after each slide change.
    function updateCounter(slick) {
      if (!$counterCurrent.length || !slick) return;
      var slidesToShow = slick.options.slidesToShow || 1;
      var startIdx = (slick.currentSlide || 0) + 1;
      var endIdx   = visibleEndIndex(slick.currentSlide || 0, slidesToShow);
      $counterCurrent.text(startIdx);
      $counterEnd.text(endIdx);
    }

    $slider.on("init", function (event, slick) {
      updateCounter(slick);
    });
    $slider.on("afterChange", function (event, slick) {
      updateCounter(slick);
    });
    $slider.on("breakpoint", function (event, slick) {
      // Slick re-evaluates slidesToShow on viewport changes; resync
      // the counter so it reflects the new visible range.
      updateCounter(slick);
    });

    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    // Wire up the custom header buttons to Slick's API. `slickPrev`
    // and `slickNext` advance the slider; Slick handles the
    // `slick-disabled` class on the buttons via the listeners we
    // bind below (since Slick's native prev/next aren't doing it).
    if ($prevBtn.length) {
      $prevBtn.on("click", function () { $slider.slick("slickPrev"); });
    }
    if ($nextBtn.length) {
      $nextBtn.on("click", function () { $slider.slick("slickNext"); });
    }

    // Reflect "can't go further" state on the header buttons. Slick
    // exposes `currentSlide` + total slides via the slick instance
    // attached to the element after init.
    function refreshDisabledState() {
      var slick = $slider.slick("getSlick");
      if (!slick) return;
      var slidesToShow = slick.options.slidesToShow || 1;
      var atStart = slick.currentSlide <= 0;
      var atEnd   = (slick.currentSlide + slidesToShow) >= totalCount;
      $prevBtn.toggleClass("slick-disabled", atStart).attr("aria-disabled", atStart);
      $nextBtn.toggleClass("slick-disabled", atEnd).attr("aria-disabled", atEnd);
    }
    $slider.on("afterChange init breakpoint", refreshDisabledState);
    // Initial state pass (slick already initialised before our
    // listeners attached in some scenarios — call once to be sure).
    refreshDisabledState();
  }
  // Case Studies Slider End Here

  // js-explore-more-topics-slider Start Here
  if ($(".js-explore-more-topics-slider").length > 0) {
    $(".js-explore-more-topics-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" transform="rotate(-180 20.5 21)" fill="#7D86BC" stroke="#7D86BC"/><path d="M23 15.5L17 21.5L23 27.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" fill="#7D86BC" stroke="#7D86BC"/><path d="M18 26.5L24 20.5L18 14.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            variableWidth: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
            arrows: true,
          },
        },
      ],
    });
  }
  // js-explore-more-topics-slider End Here

  // js-other-completed-projects Start Here
  if ($(".js-other-completed-projects").length > 0) {
    $(".js-other-completed-projects").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: false,
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" transform="rotate(-180 20.5 21)" fill="#7D86BC" stroke="#7D86BC"/><path d="M23 15.5L17 21.5L23 27.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" fill="#7D86BC" stroke="#7D86BC"/><path d="M18 26.5L24 20.5L18 14.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            variableWidth: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
            arrows: true,
          },
        },
      ],
    });
  }
  // js-other-completed-projects End Here

  let trustedLogo = $(".trusted-logo__slider");
  if (trustedLogo.length > 0 && !trustedLogo.hasClass("slick-initialized")) {
    trustedLogo.slick({
      dots: false,
      arrows: false,
      slidesToShow: 5,
      infinite: true,
      lazyLoad: "progressive",
      speed: 3000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: "linear",
      draggable: false,
      swipe: false,
      touchMove: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      swipeToSlide: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            speed: 8000,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            speed: 3000,
          },
        },
      ],
    });
  }

  let jsTrustedBrandsSlider = $(".js-trusted-brands-slider");
  if (jsTrustedBrandsSlider.length > 0 && !jsTrustedBrandsSlider.hasClass("slick-initialized")) {
    jsTrustedBrandsSlider.slick({
      dots: false,
      arrows: false,
      slidesToShow: 5,
      infinite: true,
      lazyLoad: "progressive",
      speed: 3000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: "linear",
      draggable: false,
      swipe: false,
      touchMove: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      swipeToSlide: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            speed: 8000,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            speed: 3000,
          },
        },
      ],
    });
  }

  if ($(".eq-expand-your-safety__content .box .text-desc").length > 0) {
    $(".eq-expand-your-safety__content .box .text-desc").matchHeight({
      byRow: true,
    });
  }
  if ($(".eq-expand-your-safety__content .box h4").length > 0) {
    $(".eq-expand-your-safety__content .box h4").matchHeight({
      byRow: true,
    });
  }
  if (
    $(".eq-our-bestsellers__content .box-main .box__desc .product-title")
      .length > 0
  ) {
    $(
      ".eq-our-bestsellers__content .box-main .box__desc .product-title"
    ).matchHeight({
      byRow: true,
    });
  }
  if (
    $(".eq-our-bestsellers__content .box-main .box__desc .text-desc").length > 0
  ) {
    $(
      ".eq-our-bestsellers__content .box-main .box__desc .text-desc"
    ).matchHeight({
      byRow: true,
    });
  }
  if ($(".eq-our-customers__content .box__desc .text-desc").length > 0) {
    $(".eq-our-customers__content .box__desc .text-desc").matchHeight({
      byRow: true,
    });
  }
  if ($(".explore-more-topics__box-desc h3").length > 0) {
    $(".explore-more-topics__box-desc h3").matchHeight({
      byRow: false,
    });
  }
  if ($(".explore-more-topics__box-desc .text-desc").length > 0) {
    $(".explore-more-topics__box-desc .text-desc").matchHeight({
      byRow: false,
    });
  }

  // Truncet on mobile text js start here
  if ($(".white-papper-article__index-list li a").length > 0) {
    $(".white-papper-article__index-list li a").Cuttr({
      truncate: "characters",
      length: 25,
    });
  }
  function applyCuttr() {
    if ($(window).width() <= 768) {
      if ($(".eq-expand-your-safety__content .box .text-desc").length > 0) {
        $(".eq-expand-your-safety__content .box .text-desc").Cuttr({
          truncate: "words",
          length: 10,
        });
      }
    }
  }
  applyCuttr();

  $(window).on("resize", function () {
    applyCuttr();
  });
  // Truncet on mobile text js end here

  // FAQ filter start here
  $(".js-accordian-title").click(function (j) {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .parents(".cus-accordian")
        .find(".cus-accordian__card")
        .removeClass("active");
      $(this).next().slideUp();
    } else {
      $(".js-accordian-title").removeClass("active");
      $(this)
        .parents(".cus-accordian")
        .find(".cus-accordian__card")
        .removeClass("active");
      $(".js-accordian-title").next().slideUp();
      $(this).addClass("active");
      $(this).parents(".cus-accordian__card").addClass("active");
      $(this)
        .next()
        .slideDown(function () {
          $(this).css("display", "block");
        });
    }
  });

  if ($(".eq-faq .eq-faq__filter-head").length > 0) {
    $(".eq-faq__filter-head button:first").addClass("active");
    let initialdataFilters = $(".js-filter-button").attr("data-filter");
    $(".cus-accordian__card").addClass("is-hidden");
    if (initialdataFilters == "general") {
      // $('.cus-accordian__card').removeClass('is-hidden');
      if ($('.cus-accordian__card[data-filter="general"]').length === 0) {
        $('.js-filter-button[data-filter="general"]').hide();
        // Activate the first available filter
        const nextFilterButton = $(".js-filter-button")
          .not('[data-filter="general"]')
          .first();
        if (nextFilterButton.length > 0) {
          nextFilterButton.addClass("active");
          let nextFilter = nextFilterButton.attr("data-filter");
          $(
            '.cus-accordian__card[data-filter="' + nextFilter + '"]'
          ).removeClass("is-hidden");
        }
      } else {
        $('.cus-accordian__card[data-filter="general"]').removeClass(
          "is-hidden"
        );
      }
    }
  }
  $(window).on("load", function () {
    if ($(".eq-faq .eq-faq__filter-head").length > 0) {
      $(".eq-faq__filter-head button:first").click();
    }

    $(".customise-btn").on("click", function (e) {
      e.preventDefault();
      $("html, body").animate({ scrollTop: 0 }, "smooth");
    });
  });

  $(".js-filter-button").on("click", function () {
    $(this).addClass("active").siblings().removeClass("active");
    let dataFilter = $(this).attr("data-filter");
    if (
      $('.cus-accordian__card[data-filter="' + dataFilter + '"]').length === 0
    ) {
      $(this).hide(); // Hide the button if no matching cards
    } else {
      $(".cus-accordian__card").addClass("is-hidden");
      $('.cus-accordian__card[data-filter="' + dataFilter + '"]').removeClass(
        "is-hidden"
      );
    }
  });
  // FAQ filter end here

  // Blog Filter js start here
  // if ($('.eq-blog-list__filter-head').length > 0) {
  //     let filterButtons = $('.js-blog-filter-button');
  //     let blogBoxes = $('.eq-blog-list__box');
  //     let dynamicBlogBoxes = $('.dynamic-posts');

  //     // Set initial active filter button
  //     filterButtons.removeClass('active');
  //     let initialFilter = filterButtons.first().attr('data-filter');
  //     filterButtons.first().addClass('active');

  //     // Hide all blog boxes initially
  //     blogBoxes.addClass('is-hidden');
  //     let initialFilterLatestPost = $(".eq-blog-list__box[data-filter='LatestPosts']");

  //     // Show only the initial filter's content
  //     if (initialFilter === initialFilterLatestPost) {
  //         initialFilterLatestPost.removeClass('is-hidden'); // Show all posts for 'LatestPosts'
  //         dynamicBlogBoxes.addClass('is-hidden'); // Hide all other post tabs
  //     } else {
  //         let initialContent = $('.eq-blog-list__box[data-filter="' + initialFilter + '"]');
  //         if (initialContent.length) {
  //             initialContent.removeClass('is-hidden');
  //         } else {
  //             filterButtons.first().hide(); // Hide button if no content exists
  //         }
  //     }
  // }

  // // Filter button click event
  // $('.js-blog-filter-button').on('click', function() {
  //     let thisButton = $(this);
  //     let dataFilter = thisButton.attr('data-filter');

  //     // Toggle active state
  //     thisButton.addClass('active').siblings().removeClass('active');

  //     // Hide all blog boxes and show only the selected one
  //     $('.eq-blog-list__box').addClass('is-hidden');

  //     if (dataFilter === "LatestPosts") {
  //         $('.eq-blog-list__box').removeClass('is-hidden'); // Show all posts
  //     } else {
  //         let filteredContent = $('.eq-blog-list__box[data-filter="' + dataFilter + '"]');
  //         if (filteredContent.length) {
  //             filteredContent.removeClass('is-hidden');
  //         } else {
  //             console.log("No content available for this category.");
  //         }
  //     }
  // });
  // Blog Filter js end here

  // Blog Filter js start here

  // On click filter buttons
  $(".js-blog-filter-button").on("click", function () {
    $(this).addClass("active").siblings().removeClass("active");
    let dataFilter = $(this).attr("data-filter");

    // Hide all and show only the selected filter
    $(".eq-blog-list__box").addClass("is-hidden");
    $('.eq-blog-list__box[data-filter="' + dataFilter + '"]').removeClass(
      "is-hidden"
    );

    // Hide button if no matching content
    if (
      $('.eq-blog-list__box[data-filter="' + dataFilter + '"]').length === 0
    ) {
      //    console.log("Filter Length : ", $('.eq-blog-list__box[data-filter="' + dataFilter + '"]').length);
      // $(this).hide();
    }

    let filterParent = $(
      '.eq-blog-list__box[data-filter="' + dataFilter + '"]'
    ).parent(".eq-blog-list__filter-content");
    if (!filterParent.hasClass("blog-filter-content-active")) {
      filterParent.addClass("blog-filter-content-active");
    }
    filterParent.siblings(".eq-blog-list__filter-content").each(function () {
      if ($(this).hasClass("blog-filter-content-active")) {
        $(this).removeClass("blog-filter-content-active");
      }
    });

    blogFilterDataMatchHeight();
  });
  // Blog Filter js end here

  if ($(window).width() < 991) {
    $(document).on("click", ".js-inner-title", function () {
      // Close all inner menus except the one being clicked
      $(".box-disc")
        .not($(this).parents(".box-disc"))
        .removeClass("active")
        .find(".inner-nav")
        .slideUp();

      // Toggle the clicked inner menu
      $(this).parents(".box-disc").toggleClass("active");
      $(this).parents(".box-disc").find(".inner-nav").slideToggle();
    });

    $(document).on("click", ".js-main-link", function () {
      // Close all main menus except the one being clicked
      $(".mega-menu-hover")
        .not($(this).parents(".mega-menu-hover"))
        .removeClass("active")
        .find(".mega-menu")
        .slideUp();

      // Toggle the clicked main menu
      $(this).parents(".mega-menu-hover").toggleClass("active");
      $(this).parents(".mega-menu-hover").find(".mega-menu").slideToggle();
    });
  }

  // Footer Accordian js start here
  function footerAddClassMobile() {
    if ($(window).width() <= 768) {
      console.log("test toggle");
      $(".eq-footer .eq-footer__nav-wrap:first").toggleClass("active");
      $(".eq-footer .eq-footer__nav-wrap:first")
        .find(".eq-footer__nav-list")
        .slideToggle();
    }
  }
  footerAddClassMobile();
  $(document).on("click", ".js-footer-nav-title", function () {
    // Close all inner menus except the one being clicked
    $(".eq-footer__nav-wrap")
      .not($(this).parents(".eq-footer__nav-wrap"))
      .removeClass("active")
      .find(".eq-footer__nav-list")
      .slideUp();

    // Toggle the clicked inner menu
    $(this).parents(".eq-footer__nav-wrap").toggleClass("active");
    $(this)
      .parents(".eq-footer__nav-wrap")
      .find(".eq-footer__nav-list")
      .slideToggle();
  });
  // Footer Accordian js end here
  $(document).on("click", ".view-more-swatch", function () {
    $(this).find(".main-product__swatch-text").text("Show Less");
    $(this).removeClass("view-more-swatch");
    $(this).addClass("view-less-swatch");
    $(this)
      .parents(".main-product__color-option")
      .find(".deafult-hidden-swatches")
      .show();
  });
  $(document).on("click", ".view-less-swatch", function () {
    $(this).find(".main-product__swatch-text").text("Show more");
    $(this).removeClass("view-less-swatch");
    $(this).addClass("view-more-swatch");
    $(this)
      .parents(".main-product__color-option")
      .find(".deafult-hidden-swatches")
      .hide();
  });

  /*
   $('.main-product__color-option input[type="radio"]').change(function() {
       console.log($('input[name="color-swatch"]:checked').val());
   });
   */

  $('input[name="width"]').on("input", function () {
   
    const inputValue = $(this).val();
    
    //    if (inputValue < 50) {
    //        $('input[name="width"]').parents('.custom-widht-grid').find('.size-error-message').show();
    //    } else {
    //        $('input[name="width"]').parents('.custom-widht-grid').find('.size-error-message').hide();
    //    }
    if (inputValue < 50) {
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message")
        .show();
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--required")
        .hide();
    } else {
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message")
        .hide();
    }

    if (inputValue > 200) {
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--max")
        .show();
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--required")
        .hide();
    } else {
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--max")
        .hide();
    }

    if (inputValue === "") {
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--required")
        .show();
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message")
        .hide();
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--max")
        .hide();
    } else {
      $('input[name="width"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--required")
        .hide();
    }
  });

  $('input[name="length"]').on("input", function () {
    const inputValue = $(this).val();
    if (inputValue > 550) {
      $('input[name="length"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message")
        .show();
    } else {
      $('input[name="length"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message")
        .hide();
    }

    if (inputValue < 50) {
      $('input[name="length"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--min")
        .show();
    } else {
      $('input[name="length"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--min")
        .hide();
    }

    if (inputValue === "") {
      $('input[name="length"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message-length--required")
        .show();
      $('input[name="length"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message--min")
        .hide();
      $('input[name="length"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message")
        .hide();
    } else {
      $('input[name="length"]')
        .parents(".custom-widht-grid")
        .find(".size-error-message-length--required")
        .hide();
    }
  });

  function qty_cal_150(_this) {
    var width = Number(
      _this
        .closest(".product-calculations-150max")
        .find("input.width_cal_150")
        .val()
    );
    var length = Number(
      _this
        .closest(".product-calculations-150max")
        .find("input.length_cal_150")
        .val()
    );
    var qty = (width * length) / 100;
    _this
      .closest(".product-calculations-150max")
      .find("#quantity")
      .val(Math.ceil(qty));
    _this
      .closest(".product-calculations-150max")
      .find("#quantity")
      .attr("value", Math.ceil(qty));
    _this.closest(".product-calculations-150max").find(".pric_cal").html("");
    _this
      .closest(".main-product")
      .find("#product-price")
      .html(
        _this.closest(".main-product").find("#product-price").attr("data-price")
      );
    if (
      _this
        .closest(".product-calculations-150max")
        .find("input.length_cal_150")
        .val() != "" &&
      _this
        .closest(".product-calculations-150max")
        .find("input.width_cal_150")
        .val() != ""
    ) {
      var mf = _this
        .closest(".product-calculations-150max")
        .find(".pric_cal")
        .attr("data-money_for");
      var price = _this
        .closest(".product-calculations-150max")
        .find(".pric_cal")
        .attr("data-price_product");
      _this
        .closest(".product-calculations-150max")
        .find(".pric_cal")
        .html(Shopify.formatMoney(Math.ceil(qty) * price, mf));
      _this
        .closest(".main-product")
        .find("#product-price")
        .html(Shopify.formatMoney(Math.ceil(qty) * price, mf));
      _this.closest(".main-product").find(".hide_price_text").hide();
    }
  }

  $("input.width_cal_150, input.length_cal_150").on("input", function () {
    
    const inputValue = $(this).val();
    if (
      inputValue < parseInt($(this).attr("min")) ||
      inputValue > parseInt($(this).attr("max"))
    ) {
      $(this).parents(".custom-widht-grid").find(".size-error-message").show();
      $(this)
        .closest(".product-calculations-150max")
        .find(".custom-atc-basket")
        .attr("disabled", "disabled");
      $(this).closest(".main-product").find(".hide_price_text").show();
    } else {
      $(this).parents(".custom-widht-grid").find(".size-error-message").hide();
      if (
        $(this)
          .closest(".product-calculations-150max")
          .find("input.length_cal_150")
          .val() != "" &&
        $(this)
          .closest(".product-calculations-150max")
          .find("input.width_cal_150")
          .val() != ""
      ) {
        $(this)
          .closest(".product-calculations-150max")
          .find(".custom-atc-basket")
          .removeAttr("disabled");
      }
    }
    qty_cal_150($(this));
  });

  $(document).on("click", ".main-product__button", function () {
    const fileInput = document.querySelector(
      ".main-product__upload-file-input"
    );
    const file = fileInput.files[0];

    // Remove the file requirement check - logo is now optional
    // if (!file) {
    //   alert("Please select a file to upload.");
    //   return;
    // }
    
    var isValid = true;
    var selected_size_dropdown = $(
      ".main-product__size-option .cw-product-bundle__variant-selected .cw-product-bundle__variant-text"
    ).text();
    
    if (
      (selected_size_dropdown && selected_size_dropdown.includes("custom")) ||
      (selected_size_dropdown && selected_size_dropdown.includes("Custom")) ||
      (selected_size_dropdown && selected_size_dropdown.includes("CUSTOM"))
    ) {
      let minWidthValue = 50;
      let maxWidthValue = 200;
      let width_val = parseFloat($('input[name="width"]').val());
      console.log("Width Value : ");
      if (width_val < minWidthValue || isNaN(width_val)) {
        isValid = false;
        $('input[name="width"]')
          .parents(".custom-widht-grid")
          .find(".size-error-message")
          .show();
      }
      if (width_val > maxWidthValue ) {
        isValid = false;
        $('input[name="width"]')
          .parents(".custom-widht-grid")
          .find(".size-error-message--max")
          .show();
      } 
      let minLengthValue = 550;
      let length_val = parseFloat($('input[name="length"]').val());
      if (length_val > minLengthValue || isNaN(length_val)) {
        $('input[name="length"]')
          .parents(".custom-widht-grid")
          .find(".size-error-message")
          .show();
        isValid = false;
      }
    }

    if (isValid) {
      Fancybox.show([
        {
          src: "#secure-checkout",
          type: "inline",
        },
      ]);
    }
  });

  // lozad js
  const observer = lozad(); // lazy loads elements with default selector as ".lozad"
  observer.observe();

  // collection product card Js

  if ($(".product-grid .card .card__information .card__heading").length > 0) {
    $(".product-grid .card .card__information .card__heading").matchHeight({
      byRow: true,
    });
  }

  if (
    $(".product-grid .card .card__information .product-attribute").length > 0
  ) {
    $(".product-grid .card .card__information .product-attribute").matchHeight({
      byRow: true,
    });
  }

  if (
    $(".product-grid .card .card__information .card-information > .price")
      .length > 0
  ) {
    $(
      ".product-grid .card .card__information .card-information > .price"
    ).matchHeight({
      byRow: true,
    });
  }

  /*
   if($('.eq-blog-list__box-desc h2').length > 0){
       $('.eq-blog-list__box-desc h2').matchHeight({
           byRow: true,
       });        
   }

   if($('.eq-blog-list__box-desc .text-desc').length > 0){
       $('.eq-blog-list__box-desc .text-desc').matchHeight({
           byRow: true,
       });        
   }
   */

  // Function to handle file upload and preview
  let fileInput = document.querySelector(".main-product__upload-file-input");
  if (fileInput) {
    fileInput.addEventListener("change", async function () {
      console.log("File added:", this);
      const file = this.files[0];
      if (!file) return; // Check if a file was selected

      console.log("Selected file:", file);
      const formData = new FormData();
      formData.append("file", file);

      // Uploading state: message + spinner while the file is in flight
      const uploadOption = document.querySelector(".main-product__upload-option");
      const statusMessage = document.getElementById("statusMessage");
      if (uploadOption) uploadOption.classList.add("is-uploading");
      if (statusMessage) {
        statusMessage.textContent = "Uploading your logo…";
        statusMessage.classList.add("is-uploading");
        statusMessage.classList.remove("is-error");
      }

      try {
        const response = await fetch(
          "https://firstmatsproofs.co.uk/firstmatsproofs.co.uk/eq-pdp-image/imgupload.php",
          {
            method: "POST",
            body: formData,
          }
        );

        if (response.ok) {
          const result = await response.json();
          console.log("Upload response:", result);

          if (result.fileUrl) {
            // Store the file URL in hidden input for later use
            document.querySelector(".main-product__uploaded-file-url").value = result.fileUrl;
            
            // Check if file is PDF or image
            const isPDF = file.type === 'application/pdf';
            
            if (isPDF) {
              // Display PDF icon/name instead of preview
              document.querySelector(
                ".main-product__upload-preview"
              ).innerHTML = `
                <div style="text-align: center; padding: 10px;">
                  <svg width="44" height="44" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#7D86BC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14 2V8H20" stroke="#7D86BC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <p style="margin-top: 5px; font-size: 12px; color: #7D86BC;">${file.name}</p>
                </div>
              `;
            } else {
              // Display the uploaded image preview
              document.querySelector(
                ".main-product__upload-preview"
              ).innerHTML = `<img src="${result.fileUrl}" alt="Uploaded Image">`;
            }

            // Update status and UI
            document.getElementById("statusMessage").textContent =
              "Logo uploaded successfully!";
            document.querySelector(".main-product__upload-icon").style.display =
              "none";
            document.querySelector(
              ".main-product__upload-remove"
            ).style.display = "block";
          } else {
            document.getElementById("statusMessage").textContent =
              "Failed to retrieve the file URL.";
            if (statusMessage) statusMessage.classList.add("is-error");
          }
        } else {
          document.getElementById("statusMessage").textContent =
            "File upload failed.";
          if (statusMessage) statusMessage.classList.add("is-error");
        }
      } catch (error) {
        console.error("Error:", error);
        document.getElementById("statusMessage").textContent =
          "An error occurred during file upload.";
        if (statusMessage) statusMessage.classList.add("is-error");
      } finally {
        if (uploadOption) uploadOption.classList.remove("is-uploading");
        if (statusMessage) statusMessage.classList.remove("is-uploading");
      }
    });
  }

  // Function to handle image removal
  let fileUploadRemove = document.querySelector(".main-product__upload-remove");
  if (fileUploadRemove) {
    fileUploadRemove.addEventListener("click", function () {
      // Clear the preview and reset the UI
      document.querySelector(".main-product__upload-preview").innerHTML = "";
      document.getElementById("statusMessage").textContent = "";
      document.querySelector(".main-product__upload-icon").style.display = "block";
      document.querySelector(".main-product__upload-remove").style.display = "none";

      // Reset the file input value to allow re-selection of the same file
      document.querySelector(".main-product__upload-file-input").value = "";

      // Clear the stored file URL
      document.querySelector(".main-product__uploaded-file-url").value = "";

      // Clear the lingering status message
      const removedStatus = document.getElementById("statusMessage");
      if (removedStatus) {
        removedStatus.textContent = "";
        removedStatus.classList.remove("is-uploading", "is-error");
      }
    });
  }

  if ($(".case-studies__slider .case-studies__box-content h3").length > 0) {
    $(".case-studies__slider .case-studies__box-content h3").matchHeight({
      byRow: true,
    });
  }

  if (
    $(".case-studies__slider .case-studies__box-content .text-desc").length > 0
  ) {
    $(
      ".case-studies__slider .case-studies__box-content .text-desc"
    ).matchHeight({
      byRow: true,
    });
  }


  /* Customer review slider JS Start */

  let customerReviewSlider = $('.js-customer-review-slider');

  if(customerReviewSlider.length > 0 ){
    customerReviewSlider.each(function () {
      let currentCustomerReviewSlider = $(this);

      if (!currentCustomerReviewSlider.hasClass('slick-initialized')) {
        currentCustomerReviewSlider.slick({
          arrows: false,
          infinite: true,
          loop: true,
          slidesToShow: parseFloat($(currentCustomerReviewSlider).attr('data-slide-desktop'), 10),
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 4000,
          draggable: true,
          pauseOnHover: true,
          pauseOnFocus: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: parseFloat($(currentCustomerReviewSlider).attr('data-slide-tab'), 10),
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: parseFloat($(currentCustomerReviewSlider).attr('data-slide-mobile'), 10),
              }
            }
          ]
      });
      }

    });
  }

/* =========================================================================
 *  Mobile-only "bold-headline-only" treatment for the rich-text metafield
 *  --------------------------------------------------------------------
 *  The PDP `metafield-rich_text_field` is a list whose items follow the
 *  pattern `<li><strong>HEADLINE</strong> — supporting copy</li>`. On
 *  mobile we want only the bold headline visible (the supporting copy
 *  is too long for a phone reading pattern); on desktop both stay.
 *
 *  Approach: walk each `<li>`, find the LAST `<strong>` child, and wrap
 *  every node that comes AFTER it in a `<span class="…__detail">`. CSS
 *  in eq-product-style.css hides that span at ≤767px. The full text
 *  stays in the DOM either way so search engines see the complete
 *  bullet content and screen readers can opt to read both.
 *
 *  Idempotency: skips items that already carry a `__detail` wrapper —
 *  safe to call multiple times if the metafield re-renders via AJAX
 *  (e.g. variant change).
 * ========================================================================= */
(function () {
  'use strict';
  function wrapDetails(li) {
    if (!li || li.querySelector(':scope > .metafield-rich_text_field__detail')) return;

    /* Find the last <strong> child — handles items with multiple
       bold spans (e.g. "<strong>Headline</strong> — copy
       <strong>more</strong> trailing"). The wrap starts after the
       LAST strong so trailing standalone bolds are preserved as
       headline. */
    var children = li.childNodes;
    var lastStrongIdx = -1;
    for (var i = 0; i < children.length; i++) {
      var n = children[i];
      if (n.nodeType === 1 && n.tagName === 'STRONG') lastStrongIdx = i;
    }
    if (lastStrongIdx < 0) return;

    /* Collect everything after the last strong; bail if there's nothing
       to wrap (item is bold-only, no supporting copy). */
    var toWrap = [];
    for (var j = lastStrongIdx + 1; j < children.length; j++) toWrap.push(children[j]);
    if (!toWrap.length) return;

    var span = document.createElement('span');
    span.className = 'metafield-rich_text_field__detail';
    /* Move nodes into the span first, then insert the span at the
       collected-from position. Inserting first then moving children
       would invalidate the live `children` NodeList mid-loop. */
    toWrap.forEach(function (node) { span.appendChild(node); });
    li.appendChild(span);
  }

  function run() {
    document.querySelectorAll('.metafield-rich_text_field li').forEach(wrapDetails);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();


  /* Customer review slider JS End */

});

function blogFilterDataMatchHeight() {
  let blogListFilters = [];

  if ($(".eq-blog-list__box").length > 0) {
    $(".eq-blog-list__box").each(function () {
      let filterValue = $(this).data("filter");
      // console.log('filterValue : ', filterValue);;

      if (!blogListFilters.includes(filterValue)) {
        //    console.log(`blogListFilters : ${blogListFilters} - filterValue : ${filterValue}`);
        blogListFilters.push(filterValue);
        //    console.log(`blogListFilters : ${blogListFilters}`);
      }
    });
  }

  if (blogListFilters) {
    blogListFilters.forEach(function (filter) {
      //  console.log("filter : ", filter);

      let filterBoxes = $(
        '.eq-blog-list__box[data-filter="' +
          filter +
          '"] .eq-blog-list__box-desc'
      );

      //  console.log(`class check ${$('.eq-blog-list__filter-content').first().attr('class')}`);
      //  console.log(`child length ${$('.eq-blog-list__filter-content').first().find('.eq-blog-list__box[data-filter="' + filter + '"]')}`);

      if (filterBoxes.find("h2").length > 0) {
        filterBoxes.find("h2").matchHeight({
          byRow: true,
        });
      }

      if (filterBoxes.find(".text-desc").length > 0) {
        filterBoxes.find(".text-desc").matchHeight({
          byRow: true,
        });
      }
    });
  }
}

$(window).on("load", function () {
  if ($(".eq-blog-list__filter-head").length > 0) {
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("data-filter")) {
      let filterValue = urlParams.get("data-filter");
      $(".eq-blog-list__box").addClass("is-hidden");
      let queryParameterFilter = $(
        `.eq-blog-list__filter-button[data-filter="${filterValue}"]`
      );
      console.log("queryParameterFilter : ", queryParameterFilter);
      queryParameterFilter.trigger("click");
    } else {
      $(".eq-blog-list__filter-head button:first").addClass("active");

      // Hide all blog list items initially
      $(".eq-blog-list__box").addClass("is-hidden");

      // Show only elements with data-filter="LatestPosts" on the first load
      let latestPosts = $('.eq-blog-list__box[data-filter="LatestPosts"]');

      if (latestPosts.parent().hasClass("eq-blog-list__filter-content")) {
        latestPosts.parent().addClass("blog-filter-content-active");
      }

      if (latestPosts.length > 0) {
        latestPosts.removeClass("is-hidden");
      } else {
        // If "LatestPosts" is not available, show the first available filter
        const nextFilterButton = $(".js-blog-filter-button")
          .not('[data-filter="LatestPosts"]')
          .first();
        if (nextFilterButton.length > 0) {
          nextFilterButton.addClass("active");
          let nextFilter = nextFilterButton.attr("data-filter");
          $('.eq-blog-list__box[data-filter="' + nextFilter + '"]').removeClass(
            "is-hidden"
          );
        }
      }

      console.log("load");

      blogFilterDataMatchHeight();
    }
  }
  



  if ($(".eq-blog-gallery__filter-head").length > 0) {
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("data-filter")) {
      let filterValue = urlParams.get("data-filter");
      $(".eq-blog-list__box").addClass("is-hidden");
      let queryParameterFilter = $(
        `.eq-blog-list__filter-button[data-filter="${filterValue}"]`
      );
      console.log("queryParameterFilter : ", queryParameterFilter);
      queryParameterFilter.trigger("click");
    } else {
      $(".eq-blog-gallery__filter-head button:first").addClass("active");

      // Hide all blog list items initially
      $(".eq-blog-list__box").addClass("is-hidden");

      // Show only elements with data-filter="LatestPosts" on the first load
      let latestPosts = $('.eq-blog-list__box[data-filter="LatestPosts"]');

      if (latestPosts.parent().hasClass("eq-blog-list__filter-content")) {
        latestPosts.parent().addClass("blog-filter-content-active");
      }

      if (latestPosts.length > 0) {
        latestPosts.removeClass("is-hidden");
      } else {
        // If "LatestPosts" is not available, show the first available filter
        const nextFilterButton = $(".js-gallery-filter-button")
          .not('[data-filter="LatestPosts"]')
          .first();
        if (nextFilterButton.length > 0) {
          nextFilterButton.addClass("active");
          let nextFilter = nextFilterButton.attr("data-filter");
          $('.eq-blog-list__box[data-filter="' + nextFilter + '"]').removeClass(
            "is-hidden"
          );
        }
      }

      console.log("load");

      galleryBlogFilterDataMatchHeight();
    }
  }
});

function scrollToElement(element) {
  if (element) {
    // Get the position of the element relative to the document (top position)
    const elementPosition =
      element.getBoundingClientRect().top + window.pageYOffset;
    // Calculate the desired scroll position with the offset (100px from the top)
    const offsetPosition = elementPosition - 100; // 100px above the top
    // Scroll smoothly to the calculated position
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }
}

let blogFilterHeader = document.querySelector(".eq-blog-list__filter-head");
scrollToElement(blogFilterHeader);

let siteLoader = $(".eq-blog-list__loader");

function loadPaginatedContent(event, pageUrl, activeFilter) {
  event.preventDefault();

  if (
    !siteLoader.hasClass("is-active-loader") &&
    !$("body").hasClass("is-active-loader")
  ) {
    siteLoader.addClass("is-active-loader");
    $("body").addClass("is-active-loader");
  }

  fetch(pageUrl)
    .then((response) => response.text())
    .then((html) => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(html, "text/html");

      // Find the updated blog posts for the selected category
      let newContent = doc.querySelector(
        `.eq-blog-list__filter-content [data-filter='${activeFilter}']`
      ).parentElement.innerHTML;

      console.log(newContent);

      // Find new pagination for the active tab
      let newPagination = doc.querySelector(
        `.pagination[data-filter='${activeFilter}']`
      );

      // Replace only the content of the active tab
      document.querySelector(
        `.eq-blog-list__filter-content [data-filter='${activeFilter}']`
      ).parentElement.innerHTML = newContent;

      // Update pagination controls
      if (newPagination) {
        document.querySelector(
          `.pagination[data-filter='${activeFilter}']`
        ).innerHTML = newPagination.innerHTML;
      }

      blogFilterDataMatchHeight();

      // Hide all blog list items initially
      $(".eq-blog-list .eq-blog-list__box").addClass("is-hidden");

      let currentUrlActiveFilter = $(
        `.eq-blog-list__filter-button[data-filter="${activeFilter}"]`
      );

      currentUrlActiveFilter.trigger("click");

      if (
        siteLoader.hasClass("is-active-loader") &&
        $("body").hasClass("is-active-loader")
      ) {
        siteLoader.removeClass("is-active-loader");
        $("body").removeClass("is-active-loader");
      }

      let blogFilterHeader = document.querySelector(
        ".eq-blog-list__filter-head"
      );
      let galleryListHeader = document.querySelector(".gallery-list");
      if (blogFilterHeader) {
        scrollToElement(blogFilterHeader);
      }
      if (galleryListHeader) {
        scrollToElement(galleryListHeader);
      }
    })
    .catch((error) => {
      console.error("Error loading pagination:", error);
      if (
        siteLoader.hasClass("is-active-loader") &&
        $("body").hasClass("is-active-loader")
      ) {
        siteLoader.removeClass("is-active-loader");
        $("body").removeClass("is-active-loader");
      }
    });
}

$(document).ready(function () {
  // USPA lp Slider Start Here
  if ($(".js-lp-uspa-slider").length > 0) {
    $(".js-lp-uspa-slider").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      variableWidth: false,
      dots: false,
      draggable: false,
      pauseOnHover: false,
      swipeToSlide: false,
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide"><svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.75 7.5L1.25 4L4.75 0.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide"><svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 7.5L4.75 4L1.25 0.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            variableWidth: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
            arrows: true,
          },
        },
      ],
    });
  }
  // USPA lp Slider Start Here

  // UGC lp Slider Start Here
  if ($(".js-ugc-section-slider").length > 0) {
    $(".js-ugc-section-slider").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      variableWidth: false,
      dots: false,
      draggable: false,
      pauseOnHover: false,
      swipeToSlide: false,
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" transform="rotate(-180 20.5 21)" fill="#FFA51E" stroke="#FFA51E"/><path d="M23 15.5L17 21.5L23 27.5" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" fill="#FFA51E" stroke="#FFA51E"/><path d="M18 26.5L24 20.5L18 14.5" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            variableWidth: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
            arrows: true,
          },
        },
      ],
    });
  }
  // UGC lp Slider Start Here

  // PDP slider start here
  let petMatsProductCusNavSlider = $(
    ".js-pet-mats-product-details-main-slider"
  );
  let petMatsProductCusThumbSlider = $(
    ".js-pet-mats-product-details-nav-slider"
  );

  if (
    petMatsProductCusNavSlider.length > 0 &&
    !petMatsProductCusNavSlider.hasClass("slick-initialized") &&
    petMatsProductCusThumbSlider.length > 0 &&
    !petMatsProductCusThumbSlider.hasClass("slick-initialized")
  ) {
    petMatsProductCusNavSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      fade: false,
      infinite: true,
      speed: 500,
      asNavFor: ".js-pet-mats-product-details-nav-slider",
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide">' +
        '<svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21.1992" r="20" transform="rotate(-180 20.5 21.1992)" fill="#FFA51E" stroke="#FFA51E"/><path d="M23 15.6992L17 21.6992L23 27.6992" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        "</button>",
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide">' +
        '<svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21.1992" r="20" fill="#FFA51E" stroke="#FFA51E"/><path d="M18 26.6992L24 20.6992L18 14.6992" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        "</button>",
    });

    petMatsProductCusThumbSlider.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: ".js-pet-mats-product-details-main-slider", // corrected selector
      arrows: true,
      dots: false,
      infinite: true,
      centerMode: false,
      focusOnSelect: true,
      variableWidth: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 5,
          },
        },
      ],
    });
  }
  // PDP slider end here

  // Set countdown duration in seconds (e.g. 3 hours 39 minutes = 3*3600 + 39*60)
  let countdownSeconds = (4 * 3600);

  function updateCountdown() {
    if (countdownSeconds <= 0) {
      $('#countdown').text("0h:0m:0s");
      return;
    }

    let hours = Math.floor(countdownSeconds / 3600);
    let minutes = Math.floor((countdownSeconds % 3600) / 60);
    let seconds = countdownSeconds % 60;

    $('#countdown').text(`${hours}h:${minutes}m:${seconds}s`);

    countdownSeconds--;
  }

  // Initial update
  updateCountdown();

  // Update every second
  setInterval(updateCountdown, 1000);

  $(".js-grid-layout").masonry({
    itemSelector: ".grid-item",
    columnWidth: ".grid-sizer",
    percentPosition: true,
    gutter: 24,
  });

  function runMobileScript() {
    if (window.innerWidth <= 768) {
      $(".eq-pt-loved-by-pets__grid.mobile-show .grid-item")
        .hide()
        .slice(0, 3)
        .show();

      $("#seeMore")
        .off("click")
        .on("click", function (e) {
          e.preventDefault();
          $(".eq-pt-loved-by-pets__grid.mobile-show .grid-item:hidden")
            .slice(0, 3)
            .fadeIn("slow");

          if (
            $(".eq-pt-loved-by-pets__grid.mobile-show .grid-item:hidden")
              .length === 0
          ) {
            $("#seeMore").fadeOut("slow");
          }
        });
    } else {
      // Optionally show all items and show/hide See More on larger screens
      $(".eq-pt-loved-by-pets__grid.mobile-show .grid-item").show();
      $("#seeMore").hide();
    }
  }

  runMobileScript();

  // Run on resize
  $(window).resize(function () {
    runMobileScript();
  });

  $(".accordion__header").click(function (e) {
    // Close all open contents
    $(this).parent().siblings().removeClass("active");
    $(this).parent().toggleClass("active");
    $(".accordion__content").slideUp();
    // Toggle the current section
    const content = $(this).next(".accordion__content");
    if (!content.is(":visible")) {
      content.slideDown();
    }
  });
  if ($(".readmore__text").length > 0) {
    $("body").on("click", ".readmore__text", function (e) {
      e.preventDefault();

      const $content = $(this).parent().find(".description__content");
      const contentHeight = $content.get(0).scrollHeight; // Full content height
      const currentHeight = $content.height(); // Current height of the content

      const contentPosition = $content.offset().top; // Position of the content block relative to the page

      if (currentHeight < contentHeight) {
        // If content is collapsed, animate to show full content
        $content.stop().animate({ height: contentHeight }, 500);

        $("html, body").animate(
          {
            scrollTop: contentPosition,
          },
          500
        );

        $(this).text("Read Less");
      } else {
        $content.stop().animate({ height: 100 }, 500);

        // Simultaneously scroll the page up to the content position
        $("html, body").animate(
          {
            scrollTop: contentPosition - 100,
          },
          500
        );

        $(this).text("Read More");
      }
    });

    $(".description__content").stop().animate({ height: 100 }, 500);
  }

  $(document).on("click", ".play-pause-icon-wrap", function () {
    let clickedVideo = $(this)
      .parents(".ugc-section__box")
      .find(".ugc-video")
      .get(0);
    $(".ugc-video")
      .not(clickedVideo)
      .each(function () {
        this.pause(),
          $(this).siblings(".play-pause-icon-wrap").find(".icon-play").show(),
          $(this).siblings(".play-pause-icon-wrap").find(".icon-pause").hide();
      }),
      clickedVideo.paused
        ? (clickedVideo.play(),
          (clickedVideo.muted = !1),
          $(this).find(".icon-play").hide(),
          $(this).find(".icon-pause").show(),
          $(this).parents(".video-wrap").find(".icon-mute").hide(),
          $(this).parents(".video-wrap").find(".icon-unmute").show())
        : (clickedVideo.pause(),
          $(this).find(".icon-pause").hide(),
          $(this).find(".icon-play").show());
  }),
    $(document).on("click", ".mute-unmute-icon-wrap", function () {
      var clickedVideo = $(this)
        .parents(".ugc-section__box")
        .find(".ugc-video")
        .get(0);
      clickedVideo.muted
        ? (console.log("Unmute"),
          (clickedVideo.muted = !1),
          $(this).find(".icon-mute").hide(),
          $(this).find(".icon-unmute").show())
        : (console.log("Mute"),
          (clickedVideo.muted = !0),
          $(this).find(".icon-unmute").hide(),
          $(this).find(".icon-mute").show());
    });
});



function galleryBlogFilterDataMatchHeight() {
  let blogListFilters = [];

  if ($(".eq-blog-list__box").length > 0) {
    $(".eq-blog-list__box").each(function () {
      let filterValue = $(this).data("filter");
      // console.log('filterValue : ', filterValue);;

      if (!blogListFilters.includes(filterValue)) {
        //    console.log(`blogListFilters : ${blogListFilters} - filterValue : ${filterValue}`);
        blogListFilters.push(filterValue);
        //    console.log(`blogListFilters : ${blogListFilters}`);
      }
    });
  }

  if (blogListFilters) {
    blogListFilters.forEach(function (filter) {
      //  console.log("filter : ", filter);

      let filterBoxes = $(
        '.eq-blog-list__box[data-filter="' +
          filter +
          '"] .eq-blog-list__box-desc'
      );

      //  console.log(`class check ${$('.eq-blog-list__filter-content').first().attr('class')}`);
      //  console.log(`child length ${$('.eq-blog-list__filter-content').first().find('.eq-blog-list__box[data-filter="' + filter + '"]')}`);

      if (filterBoxes.find("h2").length > 0) {
        filterBoxes.find("h2").matchHeight({
          byRow: true,
        });
      }

      if (filterBoxes.find(".text-desc").length > 0) {
        filterBoxes.find(".text-desc").matchHeight({
          byRow: true,
        });
      }
    });
  }
}
// Blog Gallery Filter
$(".js-gallery-filter-button").on("click", function () {
 
    $(this).addClass("active").siblings().removeClass("active");
    let dataFilter = $(this).attr("data-filter");
 
    // Hide all and show only the selected filter
    $(".eq-blog-list__boxx").addClass("is-hidden");
    // $('.eq-blog-list__box[data-tag-filter="' + dataFilter + '"]').removeClass(
    //   "is-hidden"
    // );
    $('.eq-blog-list__boxx').filter(function () {
  let tags = $(this).data("tag-filter").toString().toLowerCase();
  return tags.split(',').map(t => t.trim()).includes(dataFilter.toLowerCase());
}).removeClass("is-hidden");


    // Hide button if no matching content
    if (
      $('.eq-blog-list__box[data-tag-filter="' + dataFilter + '"]').length === 0
    ) {
      //    console.log("Filter Length : ", $('.eq-blog-list__box[data-filter="' + dataFilter + '"]').length);
      // $(this).hide();
    }

    let filterParent = $(
      '.eq-blog-list__box[data-tag-filter="' + dataFilter + '"]'
    ).parent(".eq-blog-list__filter-content");
    if (!filterParent.hasClass("blog-filter-content-active")) {
      filterParent.addClass("blog-filter-content-active");
    }
    filterParent.siblings(".eq-blog-list__filter-content").each(function () {
      if ($(this).hasClass("blog-filter-content-active")) {
        $(this).removeClass("blog-filter-content-active");
      }
    });

    galleryBlogFilterDataMatchHeight();
  });
$(".js-gallery-filter-button--all").on("click", function(){
  $('.eq-blog-list__boxx').removeClass('is-hidden');
})
  $(document).ready(function () {

            $('.js-additional-pdp-slider').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                infinite: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: 2000,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 3
                        }
                    }
                ]
            });
            // $('.js-first--button').trigger('click')
  });

//   document.addEventListener('input', function(e) {
//   if (e.target.classList.contains('width_cal_150') || e.target.classList.contains('length_cal_150')) {
//     e.target.value = e.target.value.replace(/[^0-9]/g, '');
//   }
// });

// function allowOnlyNumbers(selector) {
//   document.querySelectorAll(selector).forEach(input => {
//     input.addEventListener('input', () => {
//       input.value = input.value.replace(/[^0-9]/g, '');
//     });
//   });
// }

// // Apply to both
// allowOnlyNumbers('.width_cal_150');
// allowOnlyNumbers('.length_cal_150');
// allowOnlyNumbers('.custom-width__value');
// allowOnlyNumbers('.custom-length__value');
// allowOnlyNumbers('#fourplusqty');

function isNumberKey(evt) {
  var charCode = evt.which ? evt.which : evt.keyCode;
  
  // Allow only digits (0–9)
  if (charCode >= 48 && charCode <= 57) {
    return true;
  }

  // Block everything else (including . and ,)
  return false;
}

$(document).on('click', '.mat-view-more-swatch', function() {
	$(this).find('.main-product__swatch-text').html(`Show Less <svg class="main-product__swatch-icon" width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.963906 5.26H11.0439V6.62H0.963906V5.26Z" fill="#222329"/>
</svg>`);
	$(this).removeClass('mat-view-more-swatch');
	$(this).addClass('mat-view-less-swatch');
  $('.extra_color_text').show();
	$(this).parents('.main-product__color-option').find('.deafult-hidden-swatches').show();
});
$(document).on('click', '.mat-view-less-swatch', function() {
	$(this).find('.main-product__swatch-text').html(`Show more <svg class="main-product__swatch-icon" width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.68391 5.26H11.0439V6.62H6.68391V11H5.32391V6.62H0.963906V5.26H5.32391V0.879999H6.68391V5.26Z" fill="#222329" /></svg>`);
	$(this).removeClass('mat-view-less-swatch');
	$(this).addClass('mat-view-more-swatch');
  $('.extra_color_text').hide();
	$(this).parents('.main-product__color-option').find('.deafult-hidden-swatches').hide();
});
document.querySelectorAll('input[name="background-color-swatch"]').forEach(swatch => {
	swatch.addEventListener('change', (e) => {
		boxColor = e.target.value;
		let selectedColorName = e.target.getAttribute('data-color-name');
		// Update only the inner spans — setting `.textContent` on the
		// `<p class="main-product__selected-color">` parent wiped out
		// the `<span class="main-product__selected-color-text">` (which
		// carries the "Selected:" prefix and the bold-style class) and
		// the sibling swatch span, leaving plain unstyled text.
		const selectedTextEl = document.querySelector('.main-product__selected-color-text');
		const selectedSwatchEl = document.querySelector('.main-product__selected-color-swatch');
		if (selectedTextEl) {
			selectedTextEl.textContent = 'Selected: ' + selectedColorName;
		}
		if (selectedSwatchEl && e.target.value) {
			selectedSwatchEl.style.backgroundColor = e.target.value;
		}
		// borderColor = e.target.value;
		updatePreview();
	});
});

$(document).ready(function () {
  $(".js_show-more").html(`Show more <svg class="main-product__swatch-icon" width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.68391 5.26H11.0439V6.62H6.68391V11H5.32391V6.62H0.963906V5.26H5.32391V0.879999H6.68391V5.26Z" fill="#222329" /></svg>`);
});




  let customerReviewSlider = $('.js-cient-review-slider');

  if(customerReviewSlider.length > 0 ){
    customerReviewSlider.each(function () {
      let currentCustomerReviewSlider = $(this);

      if (!currentCustomerReviewSlider.hasClass('slick-initialized')) {
        currentCustomerReviewSlider.slick({
          arrows: true,
          infinite: false,
          loop: false,
          variableWidth: true,
          autoplay: true,
          autoplaySpeed: 4000,
          draggable: true,
          pauseOnHover: true,
          pauseOnFocus: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: parseFloat($(currentCustomerReviewSlider).attr('data-slide-tab'), 10),
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: parseFloat($(currentCustomerReviewSlider).attr('data-slide-mobile'), 10),
              }
            }
          ]
      });
      }

    });
  }